import {createSlice} from '@reduxjs/toolkit';
import {httpPost} from '../../util/Rest';
import {ACCOUNTSUMMARY} from '../../constants/MicroServiceConstants';
import {CLIENT_CLASS, STATE} from '../../constants/Lookup';

const initialData = {
  advanceSearchData: {},
  dropDownData: {},
  isLoading: false,
  errorMsg: null,
  successMsg: null,
};

const slice = createSlice({
  name: 'advanceSearch',
  initialState: {
    ...initialData,
  },
  reducers: {
    fetchStart: (state) => {
      state.isLoading = true;
      state.errorMsg = null;
    },
    fetchDropDownData: (state, action) => {
      state.dropDownData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    postAdvanceSearchData: (state, action) => {
      state.advanceSearchData = action.payload.response;
      state.isLoading = false;
      state.errorMsg = null;
    },
    fetchError: (state, action) => {
      state.errorMsg = action.payload;
      state.isLoading = false;
    },
    resetMsg: (state, action) => {
      state.successMsg = null;
      state.errorMsg = null;
      state.isLoading = false;
    },
  },
});

export default slice.reducer;

// Actions

const {fetchStart, postAdvanceSearchData, fetchDropDownData, fetchError} = slice.actions;
export const fetchStateDropdown = (accountNumber) => {
  return (dispatch) => {
    dispatch(fetchStart());
    Promise.all([
      httpPost('lookup/find/all/lookup', {
        typeCode: [STATE, CLIENT_CLASS],
      }),
    ])
      .then((data) => {
        const lookUpApiData = data && data[0] ? data[0] : null;
        if (lookUpApiData && lookUpApiData.status && lookUpApiData.status === 200) {
          dispatch(fetchDropDownData(lookUpApiData.data));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.data?.error));
      });
  };
};
export const postAdvanceSearch = (details) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`${ACCOUNTSUMMARY}/search/all`, details)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(postAdvanceSearchData(data));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};
